import { render, staticRenderFns } from "./RankAttributionsTreatedDetails.vue?vue&type=template&id=1050856c"
import script from "./RankAttributionsTreatedDetails.vue?vue&type=script&lang=js"
export * from "./RankAttributionsTreatedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports